import { Component, Vue } from 'vue-property-decorator'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faPen,
	faTrashAlt,
	faPlusCircle,
	faRotateRight,
} from '@fortawesome/free-solid-svg-icons'
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons'

import fetch from '@/helpers/fetch'
import vSelect from 'vue-select'
import Fuse from 'fuse.js'
// preload
import cnjParser from '@/helpers/cnjParser'

import CreateModal from './CreateModal/index.vue'
import EditModal from './EditModal/index.vue'
import Loader from '@/components/Loader/index.vue'

library.add(faPen, faTrashAlt, faPlusCircle, faRotateRight, faCircleCheck)

@Component({
	components: {
		Loader,
		CreateModal,
		EditModal,
		vSelect,
	},
})
export default class ThermometerManagement extends Vue {
	currentPage = 1
	perPage = 20
	totalEntries = 0
	usersList = []
	editEntryId = 0
	loading = true
	fields = [
		{
			thStyle: 'min-width: 125px',
			key: 'actions',
			label: 'Ações',
		},
		{
			key: 'research_date',
			label: 'Data de pesquisa',
			thStyle: 'min-width: 125px',
			formatterType: 'date',
			formatter(value) {
				if (!value) return ''
				// YYYY-MM-DD para DD/MM/YYYY
				return value.replace(/(\d{4})-(\d{2})-(\d{2})/, '$3/$2/$1')
			},
		},
		{
			thStyle: 'min-width: 125px',
			key: 'complete_research',
			label: 'Pesquisa completa',
			formatter: (value) =>
				value === null ? '' : value === true ? 'Sim' : 'Não',
			formatterType: 'boolean',
		},
		{
			key: 'cnj',
			label: 'CNJ',
			thStyle: 'min-width: 200px',
			formatterType: 'cnj',
			formatter(value) {
				if (!value) return ''
				return value.replace(
					/(\d{7})(\d{2})(\d{4})(\d{1})(\d{2})(\d{4})/,
					'$1-$2.$3.$4.$5.$6',
				)
			},
		},
		{
			key: 'cnpj',
			label: 'CNPJ',
			thStyle: 'min-width: 150px',
			formatter(value) {
				if (!value) return ''
				return value.replace(
					/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
					'$1.$2.$3/$4-$5',
				)
			},
			formatterType: 'cnpj',
		},
		{
			key: 'company_name',
			label: 'Empresa',
			thStyle: 'min-width: 150px',
		},
		{
			key: 'calc_subject',
			label: 'Tese',
			thStyle: 'min-width: 470px',
			formatter: (value) => (value ? (value.name ? value.name : '') : ''),
			formatterType: 'name',
		},
		{
			key: 'market_sector',
			label: 'Setor',
			thStyle: 'min-width: 300px',
			formatter: (value) => (value ? (value.name ? value.name : '') : ''),
			formatterType: 'name',
		},
		{
			key: 'distribution_date',
			label: 'Data de distribuição',
			thStyle: 'min-width: 150px',
			formatter(value) {
				if (!value) return ''
				// YYYY-MM-DD para DD/MM/YYYY
				return value.replace(/(\d{4})-(\d{2})-(\d{2})/, '$3/$2/$1')
			},
			formatterType: 'date',
		},
		{
			key: 'multinational',
			label: 'Multinacional',
			thStyle: 'min-width: 125px',
			formatter: (value) =>
				value === null ? '' : value === true ? 'Sim' : 'Não',
			formatterType: 'boolean',
		},
		{
			key: 'publicly_traded',
			label: 'Capital aberto',
			thStyle: 'min-width: 125px',
			formatter: (value) =>
				value === null ? '' : value === true ? 'Sim' : 'Não',
			formatterType: 'boolean',
		},
		{
			key: 'state',
			label: 'Estado',
			thStyle: 'min-width: 100px',
		},
		{
			key: 'city',
			label: 'Cidade',
			thStyle: 'min-width: 150px',
		},
	]

	filters = {
		subject: '',
		cnpj: '',
		cnj: '',
		research_date: null,
		company_name: '',
		// company_group_name: '',
		multinational: '',
		publicly_traded: '',
		distribution_date_from: '',
		distribution_date_to: '',
		market_sector: '',
	}

	options = {
		page: [10, 20, 30, 40, 50],
		sectors: [] as Array<any>,
		calcSubjects: [] as Array<any>,
		courthouses: [] as Array<any>,
		firms: [] as Array<any>,
		companies: [] as Array<any>,
		companiesGroups: [] as Array<any>,
		states: [
			'SP',
			'RJ',
			'MG',
			'AC',
			'AL',
			'AP',
			'AM',
			'BA',
			'CE',
			'DF',
			'ES',
			'GO',
			'MA',
			'MT',
			'MS',
			'PA',
			'PB',
			'PR',
			'PE',
			'PI',
			'RN',
			'RS',
			'RO',
			'RR',
			'SC',
			'SE',
			'TO',
		],
	}

	get minDistributionDate() {
		if (this.filters.distribution_date_from) {
			return new Date(this.filters.distribution_date_from)
		}
		return null
	}

	get maxDistributionDate() {
		if (this.filters.distribution_date_to) {
			return new Date(this.filters.distribution_date_to)
		}
		return null
	}

	fuseSearch(options, search) {
		if (search.length === 0) return options

		const fuse = new Fuse(options, {
			keys: ['name'],
			shouldSort: true,
			ignoreLocation: true,
			threshold: 0.3,
		})

		return fuse.search(search).map(({ item }) => item)
	}

	clearForm() {
		this.filters.subject = ''
		this.filters.research_date = null
		this.filters.company_name = ''
		this.filters.cnj = ''
		this.filters.cnpj = ''
		this.filters.multinational = ''
		this.filters.publicly_traded = ''
		this.filters.distribution_date_from = ''
		this.filters.distribution_date_to = ''
		this.filters.market_sector = ''
	}

	openEdit(entryId) {
		this.editEntryId = entryId
		this.$bvModal.show('editar-pesquisa')
	}

	async loadCalcSubjects() {
		const res = await fetch.get('/api/calc/subjects?outdated=false')
		this.options.calcSubjects = []
		this.options.calcSubjects.push(...res.data)
	}

	async loadSectors() {
		const res = await fetch.get('/api/market-sectors')
		this.options.sectors = []
		this.options.sectors.push(...res.data)
	}

	async loadCourthouses() {
		const res = await fetch.get('/api/courthouses')
		this.options.courthouses = []
		this.options.courthouses.push(...res.data)
	}

	async loadFirms() {
		const res = await fetch.get('/api/law-firms')
		this.options.firms = []
		this.options.firms.push(...res.data)
	}

	async loadCompanies() {
		const res = await fetch.get(
			'/api/thermometer/collections/distinct/companies',
		)
		this.options.companies = []
		this.options.companies.push(...res.data)
	}

	async loadCompaniesGroups() {
		const res = await fetch.get(
			'/api/thermometer/collections/distinct/companies-groups',
		)
		this.options.companiesGroups = []
		this.options.companiesGroups.push(...res.data)
	}

	getQueryParams(filter): string[] {
		const params: string[] = []

		if (filter.subject) {
			params.push('calc_subject=' + encodeURIComponent(filter.subject))
		}

		if (filter.research_date) {
			params.push(
				'research_date=' + encodeURIComponent(filter.research_date),
			)
		}

		if (filter.distribution_date_from && filter.distribution_date_to) {
			params.push(
				'distribution_date_from=' +
					encodeURIComponent(filter.distribution_date_from),
			)
			params.push(
				'distribution_date_to=' +
					encodeURIComponent(filter.distribution_date_to),
			)
		}

		if (filter.cnj) {
			params.push(
				'cnj=' + encodeURIComponent(filter.cnj.replace(/[.-]/g, '')),
			)
		}

		if (filter.cnpj) {
			params.push(
				'cnpj=' +
					encodeURIComponent(filter.cnpj.replace(/[.\-/]/g, '')),
			)
		}

		if (filter.company_name) {
			params.push(
				'company_name=' + encodeURIComponent(filter.company_name),
			)
		}

		/*
		if (filter.company_group_name) {
			params.push(
				'company_group_name=' +
					encodeURIComponent(filter.company_group_name),
			)
		}
		*/

		if (filter.multinational) {
			params.push(
				'multinational=' + encodeURIComponent(filter.multinational),
			)
		}

		if (filter.publicly_traded) {
			params.push(
				'publicly_traded=' + encodeURIComponent(filter.publicly_traded),
			)
		}

		if (filter.market_sector) {
			params.push(
				'market_sector=' + encodeURIComponent(filter.market_sector),
			)
		}

		return params
	}

	async entriesProvider(ctx) {
		const params = this.getQueryParams(ctx.filter)

		if (ctx.currentPage === 1) {
			const resCount = await fetch.get(
				'/api/thermometer/count?page=1&items=20' +
					(params.length ? '&' + params.join('&') : ''),
			)
			this.totalEntries = resCount.data.count
		}

		params.push('page=' + ctx.currentPage, 'items=' + ctx.perPage)
		const res = await fetch.get('/api/thermometer?' + params.join('&'))

		if (res.ok) {
			return res.data.thermometer.map((entry) => {
				entry.deleting = false
				return entry
			})
		}

		return []
	}

	downloading = false
	csvHref = ''
	downloadProp = 'pesquisas-termometro.csv'
	async downloadCSV() {
		this.downloading = true
		const params = this.getQueryParams(this.filters)

		const res = await fetch.post(
			'/api/thermometer/csv?' + params.join('&'),
			this.fields,
		)

		const csvContent = res.csv

		const encodedUri = encodeURI(csvContent)

		this.csvHref = 'data:text/csv;charset=utf-8,\uFEFF' + encodedUri

		const time = new Date().getTime() - 3 * 60 * 60 * 1000

		this.downloadProp =
			'pesquisas-termometro-' +
			new Date(time).toISOString().substring(0, 16) +
			'.csv'

		await Vue.nextTick()
		const link: any = this.$refs.csvLink

		if (link && link.click) {
			link.click()
		}

		this.downloading = false
	}

	async deleteEntry(entry, index) {
		entry.deleting = true
		const res = await fetch.delete('/api/thermometer/entry/' + entry.id, {})
		entry.deleting = false
		this.reloadTable()
	}

	reloadTable() {
		const entriesTable: any = this.$refs.entriesTable
		entriesTable.refresh()
	}

	async mounted() {
		await Promise.all([
			this.loadFirms(),
			this.loadCourthouses(),
			this.loadCalcSubjects(),
			this.loadSectors(),
			this.loadCompanies(),
			this.loadCompaniesGroups(),
		])
		this.loading = false
	}
}
